import { Container, Row, Col, Card } from "react-bootstrap";

export default function Power() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Power</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Developing energy infrastructure for sustainable power generation and distribution across industries.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{ padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Hydropower Plants</Card.Title>
              <Card.Text className="text-secondary">
                Construction of hydropower plants to harness renewable energy.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{ padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Substations & Grid Systems</Card.Title>
              <Card.Text className="text-secondary">
                Enhancing power transmission with modern substations and grids.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
